import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactionPillPure from './ReactionPillPure'
import { getEmojiFromCode } from 'srcReact/helpers/utils'

const ReactionPill = (props) => {
  const { reactionCode, count, variant } = props
  const [emoji, setEmoji] = useState(null)

  useEffect(() => {
    if (reactionCode) {
      const emojiCode = getEmojiFromCode(reactionCode)
      setEmoji(emojiCode)
    }
  }, [reactionCode])
  return <ReactionPillPure count={count} emoji={emoji} variant={variant} />
}

ReactionPill.propTypes = {
  reactionCode: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  variant: PropTypes.string
}

ReactionPill.defaultProps = {
  variant: 'gray'
}

export default ReactionPill
